/* @flow */
import React from 'react';
import gql from 'graphql-tag';
import {DestinationMessage as DestinationMessageComponent} from '@homeaway/react-urgency-messaging';

import type DestinationMessage from '@homeaway/graphql-traveler-urgency-messaging';

const commonSelectionSet = `
            destinationMessage(assetVersion: 3) {
                iconTitleText {
                    title
                    message
                    icon
                    messageValueType
                    link {
                        linkText
                        linkHref
                    }
                }
                iconText {
                    message
                    icon
                    messageValueType
        }
    }
`;

export const fragments = {
    results: gql`
        fragment DestinationMessageResults on Results {
            ${commonSelectionSet}
        }
    `,
    searchResult: gql`
        fragment DestinationMessageSearchResult on SearchResult {
            ${commonSelectionSet}
        }
    `
};

export function Content(destinationMessage: DestinationMessage) {
    return (
        <div data-wdio="DestinationMessage">
            <DestinationMessageComponent
                destinationMessage={destinationMessage}
                size={'l'}
                ariaHidden
                className={'UrgencyDestinationMessage--bordered'}
            />
        </div>
    );
}
